










import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import StudentDashboardUnderstanding from '@/components/organisms/v2/StudentDashboardUnderstanding.vue'
import NursingBranch from '@/mixins/v3/NursingBranch'

@Component({
  components: {
    ColoredBox,
    ButtonBase,
    StudentDashboardUnderstanding,
  },
})
export default class TJContents extends Mixins(NursingBranch) {
  @Prop()
  understandingTotal!: {}

  @Prop()
  understandingHistories!: object[]

  private get studentName(): string {
    return Vue.prototype.$cookies.get('dataGdls')?.userNickname || ''
  }
}
